import React, { useEffect, useState, useRef, Fragment } from "react";
import ReactDOM from "react-dom";
import { StickyTable, Row, Cell } from "react-sticky-table";
import {
  Typography,
  Button,
  Tooltip,
  CircularProgress,
  Grid,
  IconButton,
} from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { api_host } from "../../../../../common/globals/constants";
import icons from "../../../../../theme/icons-semaforo.js";

export const InvertedTable = ({
  objectivesList,
  nodesIdList,
  groupedNodes,
  filter,
  onCellClick,
  handleOpenObjectiveModal,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState([]);

  const objectives = objectivesList.filter((objetivo) => {
    if (
      filter === "Todos" ||
      objetivo.estado === filter ||
      (filter === "Activos" && objetivo.estado !== "No monitoreo")
    ) {
      return objetivo;
    }
  });

  const tableRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    let token = sessionStorage.getItem("key");
    let user = sessionStorage.getItem("user");
    let lightsPeriod = parseInt(sessionStorage.getItem("period_semaphore"));

    const fetchResults = await Promise.all(
      objectivesList.map(async (objetivo) => {
        const dataApi = await fetch(
          api_host +
            `/reporte/online/indicadores/getUltimoEstadoObjetivo/?user=${user}&objetivoId=${objetivo.objetivo_id}&objectiveName=${objetivo.nombre}&lightsPeriod=${lightsPeriod}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`
        )
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            return res;
          });
        return { ...objetivo, ...dataApi };
      })
    );
    setIsLoading(false);
    setResults(fetchResults);
  };

  const processData = () => {
    const groupByNodoId = nodesIdList.map((nodoId) => {
      let cell = [];
      for (const objetivo of results) {
        if (
          filter === "Todos" ||
          objetivo.estado === filter ||
          (filter === "Activos" && objetivo.estado !== "No monitoreo")
        ) {
          let ok = false;
          let cellData = {};
          for (const node of objetivo.Objetivo.Nodo) {
            if (nodoId == node.nodo_id && !ok) {
              var colorEvent = "#41B900";
              var icon = (
                <i style={{ ...icons.sprite, ...icons.spriteSemaforoverde }} />
              );
              var nameEvent = "Ok";
              var descriptionEvent = "";
              cellData["objective"] = objetivo.Objetivo.objetivo_id;
              cellData["interval"] = objetivo.intervalo;
              cellData["node"] = node;
              cellData["monitors"] = objetivo.Monitores;
              cellData["status"] = node.Estado.nombre;
              cellData["code"] = node.Estado.id;
              if (node.Estado.id == 1) {
                icon = (
                  <i
                    style={{ ...icons.sprite, ...icons.spriteSemaforoverde }}
                  />
                );
                nameEvent = node.Estado.nombre;
                descriptionEvent =
                  "El objetivo actualmente esta uptime y sin eventos downtime durante todo en el período.";
              } else if (node.Estado.id == 2) {
                icon = (
                  <i style={{ ...icons.sprite, ...icons.spriteSemafororojo }} />
                );
                nameEvent = node.Estado.nombre;
                colorEvent = "#C2272D";
                descriptionEvent = "El objetivo actualmente esta en downtime.";
              } else if (node.Estado.id == 3) {
                icon = (
                  <i
                    style={{ ...icons.sprite, ...icons.spriteSemaforoamarillo }}
                  />
                );
                nameEvent = node.Estado.nombre;
                colorEvent = "#ebeb34";
                descriptionEvent =
                  "El objetivo actualmente esta uptime pero con eventos downtime durante parte del período.";
              } else if (node.Estado.id == 4) {
                icon = (
                  <i
                    style={{ ...icons.sprite, ...icons.spriteSemaforoblanco }}
                  />
                );
                nameEvent = node.Estado.nombre;
                colorEvent = " #A9A9A9";
                descriptionEvent =
                  "No se ha recibido nueva informaci&oacute;n del objetivo desde el ISP.";
              } else if (node.Estado.id == 5) {
                icon = (
                  <i
                    style={{ ...icons.sprite, ...icons.spriteSemaforoblanco }}
                  />
                );
                nameEvent = node.Estado.nombre;
                colorEvent = " #A9A9A9";
                descriptionEvent =
                  "El objetivo actualmente no se esta monitoreando desde el ISP.";
              } else if (node.Estado.id == 6) {
                icon = (
                  <i
                    style={{ ...icons.sprite, ...icons.spriteSemaforoblanco }}
                  />
                );
                nameEvent = node.Estado.nombre;
                colorEvent = " #A9A9A9";
                descriptionEvent = "Evento Cliente.";
              }
              cellData["descriptionEvent"] = descriptionEvent;
              cellData["nameEvent"] = nameEvent;
              cellData["icon"] = icon;
              cellData["color"] = colorEvent;
              var duration = node.Estado.duracion;
              if (duration.includes("days")) {
                duration = duration.replace("days", "día(s)");
              } else if (duration.includes("day")) {
                duration = duration.replace("day", "día");
              }
              cellData["duration"] = duration;
              cell.push(cellData);
              ok = true;
            }
          }
          if (!ok) {
            cellData["status"] = "";
            cellData["code"] = "";
            cellData["duration"] = "";
            cellData["color"] = "";
            cellData["icon"] = "";
            cellData["step"] = "";
            cell.push(cellData);
          }
        }
      }
      return { nodo: groupedNodes[nodoId][0], cells: cell };
    });

    return groupByNodoId;
  };

  const onCellClickInverted = ({ monitors, objective, interval, node }) => {
    let lightsPeriod = parseInt(sessionStorage.getItem("period_semaphore"));
    var endDate = new Date();
    endDate = endDate.getTime();
    var startDate = endDate - lightsPeriod * 1000;
    let point = [];
    point["x"] = startDate;
    point["x2"] = endDate;
    point["y"] = node;
    onCellClick(point, monitors, objective, interval);
  };

  const scroll = (scrollOffset) => {
    const scrollContainer = ReactDOM.findDOMNode(tableRef.current);
    scrollContainer.scrollLeft += scrollOffset;
  };

  if (isLoading) {
    return (
      <div style={{ marginTop: "20px" }}>
        <Typography variant="h5">
          <CircularProgress variant="indeterminate" size={24} thickness={4} />
          Cargando Información...
        </Typography>
      </div>
    );
  }

  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12}>
          <div style={{ float: "right" }}>
            <IconButton onClick={() => scroll(-516)}>
              <NavigateBeforeIcon />
            </IconButton>
            <IconButton onClick={() => scroll(516)}>
              <NavigateNextIcon />
            </IconButton>
            <Typography variant="h6" style={{ color: "black" }}>
              {objectives.length + " monitor(es)"}
            </Typography>
          </div>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          <StickyTable
            style={{ maxWidth: "100%" }}
            stickyHeaderCount={1}
            leftStickyColumnCount={2}
            ref={tableRef}
          >
            <Row>
              <Cell
                style={{
                  backgroundColor: "#373537",
                  maxWidth: "230px",
                  minWidth: "130px",
                  borderRight: "2px solid #e4dede",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    color: "white",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Monitores
                </Typography>
              </Cell>
              <Cell
                style={{
                  backgroundColor: "#373537",
                  maxWidth: "230px",
                  minWidth: "130px",
                  borderRight: "2px solid #e4dede",
                }}
              ></Cell>
              {objectives.map((objetivo) => (
                <Cell
                  key={objetivo.nombre}
                  style={{
                    backgroundColor: "#373537",
                    maxWidth: "200px",
                    minWidth: "180px",
                    borderRight: "2px solid #e4dede",
                  }}
                >
                  <Button
                    onClick={() =>
                      handleOpenObjectiveModal(
                        objetivo.objetivo_id,
                        objetivo.nombre
                      )
                    }
                  >
                    <Typography
                      variant="h6"
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {objetivo.nombre}
                    </Typography>
                  </Button>
                </Cell>
              ))}
            </Row>
            {processData().map(({ nodo, cells }, index) => (
              <Fragment key={index}>
                <Row>
                  <Cell
                    style={{
                      backgroundColor: "#7b8ebb",
                      maxWidth: "130px",
                      minWidth: "130px",
                      borderRight: "2px solid #e4dede",
                    }}
                  >
                    <Typography
                      align="left"
                      variant="h4"
                      style={{ color: "white" }}
                    >
                      {nodo.titulo.substr(0, 10)}
                    </Typography>
                  </Cell>
                  <Cell
                    style={{
                      backgroundColor: "#7b8ebb",
                      maxWidth: "130px",
                      minWidth: "130px",
                      borderRight: "2px solid #e4dede",
                    }}
                  >
                    <Typography align="left" style={{ color: "white" }}>
                      {nodo.subtitulo.substr(0, 15)}
                    </Typography>
                  </Cell>
                  {cells.map((cell, i) => (
                    <Fragment key={`${cell.nameEvent}${i}`}>
                      {cell.icon !== "" ? (
                        <Tooltip
                          title={
                            <div>
                              <Typography
                                variant="h4"
                                style={{ color: "white" }}
                              >
                                {cell.nameEvent}
                              </Typography>
                              <Typography
                                variant="h6"
                                style={{ color: "white" }}
                              >
                                {cell.descriptionEvent}
                              </Typography>
                              <Typography
                                variant="h6"
                                style={{ color: "white" }}
                              >
                                {"Duración: " + cell.duration}
                              </Typography>
                            </div>
                          }
                          placement="bottom"
                          arrow
                        >
                          <Cell
                            style={{
                              maxWidth: "130px",
                              minWidth: "130px",
                              borderBottom: "2px solid #d4d4d4",
                              borderRight: "2px solid #e4dede",
                              backgroundColor: "#e9e9e9",
                            }}
                          >
                            <Typography style={{ height: "30px" }}>
                              <Button
                                id={i}
                                onClick={() =>
                                  onCellClickInverted({
                                    monitors: cell.monitors,
                                    objective: cell.objective,
                                    interval: cell.interval,
                                    node: nodo.nodo,
                                  })
                                }
                              >
                                {cell.icon}
                              </Button>
                            </Typography>
                          </Cell>
                        </Tooltip>
                      ) : (
                        <Cell
                          style={{
                            maxWidth: "130px",
                            minWidth: "130px",
                            borderBottom: "2px solid #d4d4d4",
                            borderRight: "2px solid #e4dede",
                            backgroundColor: "#e9e9e9",
                          }}
                        />
                      )}
                    </Fragment>
                  ))}
                </Row>
              </Fragment>
            ))}
          </StickyTable>
        </Grid>
      </Grid>
    </>
  );
};
